/* md-patch-labels.js - o NOME e o LOCAL de cada patch, vindos do Worker md-labels.
 * Irmao do md-team-names.js, e o UNICO arquivo do tema que escreve nome de patch na tela.
 *
 * ============================ A CONVENCAO DOS ATRIBUTOS ============================
 * Vale igual na PDP e no carrinho. Da pra conferir olhando o HTML servido:
 *
 *   data-md-patch-texto="P41"    <span>  ALVO. O Worker escreve o texto AQUI DENTRO.
 *   data-md-patch-campo="n"      <span>  qual campo entra: "n" = nome, "l" = local exibido.
 *                                        Ausente vale "n".
 *   data-md-patch-ok="1"                 marca posta por ESTE arquivo no alvo ja pintado
 *                                        ("sem-rotulo" quando o dicionario nao conhece o codigo)
 *
 *   data-md-patch-codigo="P41"   <input> CONTROLE. Qual patch o checkbox seleciona.
 *   data-md-patch-local="Chest"  <input> CONTROLE. Local GRAVADO (grupo de exclusividade).
 *
 * Regra de bolso: SO se pinta o que tem `data-md-patch-texto`, e o valor dele e sempre um
 * CODIGO. Os dois atributos de <input> terminam em `-codigo`/`-local`, nunca sao pintados,
 * e o `-local` deles guarda uma PALAVRA (Chest), nao um codigo. Se algum dia aparecer nome
 * de patch fora de um `data-md-patch-texto`, e bug de neutralidade.
 *
 * ================================== POR QUE ASSIM ==================================
 * O tema so conhece CODIGO (P41). O nome vive fora da Shopify, em GET <base>/patches, e so
 * existe no navegador. E a mesma regra que ja vale pro nome dos times.
 *
 * Resposta do Worker:
 *   { "p:P41": { "n": "...", "l": "Chest", "i": "md-patch-p41.png" },
 *     "p:P28": { "n": "...", "l": "Legacy", "i": "md-patch-p28.png", "d": "Sleeve" } }
 *
 * O local tambem passa por aqui porque grupo de exclusividade e rotulo exibido nem sempre
 * sao a mesma palavra: os 6 do grupo "Legacy" aparecem como "Sleeve" (campo "d"). O que
 * fica GRAVADO no pedido continua sendo o grupo - quem le o pedido e o motor da planilha
 * do fornecedor, nao o cliente.
 *
 * Velocidade: cache local de 24h lido de forma SINCRONA, entao visita repetida reescreve
 * antes do primeiro paint. Enquanto o dicionario nao chega, os alvos ficam numa fila.
 *
 * Worker fora do ar: fica o CODIGO na tela ("P41 - Chest" no carrinho, "P41" na PDP).
 * Neutro, legivel, e a loja segue vendendo.
 *
 * ATENCAO: este arquivo PODE levar defer, ao contrario do md-team-names.js. O nome do time
 * esta no titulo do produto, no caminho critico da vitrine, e por isso aquele arquivo nunca
 * pode levar defer nem perder o preconnect. O nome do patch so aparece dentro do bloco da
 * PDP e dentro do carrinho - nenhum dos dois no primeiro paint.
 */
(function () {
  'use strict';

  /* Dois <script> com o mesmo src podem existir na mesma pagina (bloco da PDP + camada de
     carrinho). O segundo sai daqui sem fazer nada. */
  if (window.mdPatchLabels) return;

  var ATTR_ALVO = 'data-md-patch-texto';
  var ATTR_CAMPO = 'data-md-patch-campo';
  var PRONTO = 'data-md-patch-ok';
  var CHAVE_CACHE = 'md_patches_v1';
  var TTL = 24 * 3600 * 1000;

  var MAPA = null;
  var fila = [];

  /* ---------- dicionario: cache local primeiro, rede depois ---------- */

  function doCache() {
    try {
      var cru = localStorage.getItem(CHAVE_CACHE);
      if (!cru) return null;
      var o = JSON.parse(cru);
      if (!o || !o.map || Date.now() - o.ts > TTL) return null;
      return o.map;
    } catch (e) {
      return null;
    }
  }

  function guardar(map) {
    try {
      localStorage.setItem(CHAVE_CACHE, JSON.stringify({ ts: Date.now(), map: map }));
    } catch (e) {}
  }

  function buscar(revalidando) {
    var base = document.documentElement.getAttribute('data-md-labels');
    if (!base || typeof fetch !== 'function') return;
    var opcoes = { credentials: 'omit' };
    /* Na revalidacao forco o navegador a perguntar ao servidor: sem isso um patch novo so
       apareceria no dia seguinte. O Worker responde 304 quando nada mudou. */
    if (revalidando) opcoes.cache = 'no-cache';
    /* mdHost (bloco inline do layout): endereco bloqueado cai pro outro do mesmo servico. */
    var pedido = window.mdHost
      ? window.mdHost.buscar(base, '/patches', opcoes, 'patches')
      : fetch(base + '/patches', opcoes);
    pedido
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        if (!j || !Object.keys(j).length) return;
        guardar(j);
        aplicar(j);
      })
      .catch(function () {
        /* servico fora do ar: fica o codigo na tela */
      });
  }

  /* Dicionario novo por cima de um cache antigo. Aqui, ao contrario do md-team-names.js,
     da pra reaplicar em TODO alvo: a reescrita e substituicao do texto inteiro, nunca
     prefixo, entao repetir nao duplica nada. */
  function aplicar(map) {
    MAPA = map;
    var espera = fila;
    fila = [];
    for (var i = 0; i < espera.length; i++) {
      espera[i].removeAttribute(PRONTO);
      tratar(espera[i]);
    }
    var pendentes = document.querySelectorAll('[' + PRONTO + '="sem-rotulo"]');
    for (var k = 0; k < pendentes.length; k++) {
      pendentes[k].removeAttribute(PRONTO);
      tratar(pendentes[k]);
    }
    varrer(document);
  }

  /* ---------- reescrita ---------- */

  function registro(codigo) {
    if (!codigo || !MAPA) return null;
    var r = MAPA['p:' + codigo];
    return r && typeof r === 'object' ? r : null;
  }

  function tratar(el) {
    if (!el || el.nodeType !== 1 || el.hasAttribute(PRONTO)) return;
    if (!el.hasAttribute(ATTR_ALVO)) return;
    if (!MAPA) {
      fila.push(el);
      return;
    }
    var r = registro(el.getAttribute(ATTR_ALVO));
    if (!r) {
      /* codigo que o dicionario nao conhece: fica o que a Shopify serviu (o proprio
         codigo, ou o local gravado). Nunca fica em branco. */
      el.setAttribute(PRONTO, 'sem-rotulo');
      return;
    }
    var texto = el.getAttribute(ATTR_CAMPO) === 'l' ? r.d || r.l : r.n;
    if (texto && el.textContent !== texto) el.textContent = texto;
    el.setAttribute(PRONTO, '1');
  }

  function varrer(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    var alvos = raiz.querySelectorAll('[' + ATTR_ALVO + ']:not([' + PRONTO + '])');
    for (var i = 0; i < alvos.length; i++) tratar(alvos[i]);
  }

  /* ---------- inicio ---------- */

  var emCache = doCache();
  if (emCache) MAPA = emCache;

  /* O observer nao e luxo: o drawer e a /cart trocam o HTML inteiro do carrinho a cada
     mudanca de quantidade, e cada troca traz codigos novos pra reescrever. */
  if (window.MutationObserver) {
    new MutationObserver(function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var novos = mutacoes[i].addedNodes;
        for (var j = 0; j < novos.length; j++) {
          var n = novos[j];
          if (n.nodeType !== 1) continue;
          tratar(n);
          varrer(n);
        }
      }
    }).observe(document.documentElement || document, { childList: true, subtree: true });
  }

  if (!MAPA) {
    buscar(false);
  } else {
    window.addEventListener('load', function () {
      buscar(true);
    });
  }

  function passada() {
    varrer(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', passada);
  else passada();
  window.addEventListener('load', passada);
  document.addEventListener('shopify:section:load', passada);

  /* API pequena: o bloco da PDP e a camada de carrinho reaproveitam o MESMO dicionario e a
     MESMA copia em cache em vez de buscar de novo. Nada aqui grava em pedido. */
  window.mdPatchLabels = {
    mapa: function () {
      return MAPA;
    },
    registro: registro,
    nome: function (codigo) {
      var r = registro(codigo);
      return r ? r.n : null;
    },
    local: function (codigo) {
      var r = registro(codigo);
      return r ? r.d || r.l : null;
    },
    varrer: varrer
  };
})();
